module.exports = __webpack_public_path__ + "img/amsterdam_lockdown.91b32f1d.png";